import * as React from 'react';
import DataImage from '../../DataImage';
import {IFoodBanksProps} from '../../utils/models';
import makeSum from '../../../../utils/makeSum';
import TotalNonFoodOut from '../../asset/8. Non-food out.png';

const TotalFood = ({ submissions }: IFoodBanksProps) => {
    return (
        <DataImage
            image={TotalNonFoodOut}
            value={`Kg ${makeSum(submissions, 'non_food_out')}`}
            text='Total Non-food Out'
        />
    );
}

export default TotalFood;